export const PLAYER_STORAGE_KEY = 'flexwatch_player';
export const DEFAULT_PLAYER_ID = 'vidcore';

const EMBEDMASTER_BASE = 'https://watch.embed-api.stream/embed';
const VIDY_BASE = 'https://www.vidy.st';
// VidCore: TMDB-ID API with global edge caching, adaptive HLS and an
// explicitly ad-free player (no banner/click/popup ads). Sandbox below blocks
// any popup/top-navigation attempt even if the provider changes its script.
const VIDCORE_BASE = 'https://vidcore.org/embed';

const isSeriesItem = (item, mediaType) =>
  mediaType === 'tv' ||
  Boolean(item?.media_type === 'tv' || item?.original_name || item?.name);

const positiveInt = (value, fallback = 1) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.trunc(parsed) : fallback;
};

export const PLAYERS = [
  {
    id: 'embedmaster',
    name: 'Player 1',
    label: 'EmbedMaster',
    buildUrl: ({ id, isSeries, season, episode }) =>
      isSeries
        ? `${EMBEDMASTER_BASE}/tv/${id}/${season}/${episode}?autoPlay=true&autoplay=1`
        : `${EMBEDMASTER_BASE}/movie/${id}?autoPlay=true&autoplay=1`,
  },
  {
    id: 'vidy',
    name: 'Player 2',
    label: 'Vidy',
    buildUrl: ({ id, isSeries, season, episode }) =>
      isSeries
        ? `${VIDY_BASE}/tv/${id}/${season}/${episode}?autoplay=true&color=DC2626&nextEpisode=true&episodeSelector=true`
        : `${VIDY_BASE}/movie/${id}?autoplay=true&color=DC2626`,
  },
  {
    id: 'vidcore',
    name: 'Player 3',
    label: 'VidCore (Fast / Ad-free)',
    // Sandbox intentionally removed: several players need their own popups /
    // navigation for captcha, auth or stream prompts to work.
    buildUrl: ({ id, isSeries, season, episode }) =>
      isSeries
        ? `${VIDCORE_BASE}/tv/${id}/${season}/${episode}?autoplay=true&theme=f5c518`
        : `${VIDCORE_BASE}/movie/${id}?autoplay=true&theme=f5c518`,
  },
];

export const resolvePlayerId = (playerId) => {
  const known = PLAYERS.some((player) => player.id === playerId);
  return known ? playerId : DEFAULT_PLAYER_ID;
};

export const getPlayer = (playerId) =>
  PLAYERS.find((player) => player.id === resolvePlayerId(playerId));

export const buildPlayerUrl = (
  item,
  { mediaType = 'movie', season = 1, episode = 1, playerId } = {}
) => {
  if (!item || !item.id) return null;
  const player = getPlayer(playerId);
  const isSeries = isSeriesItem(item, mediaType);
  return player.buildUrl({
    id: item.id,
    isSeries,
    season: positiveInt(season),
    episode: positiveInt(episode),
  });
};

export const getStoredPlayerId = () => {
  try {
    if (typeof localStorage === 'undefined') return DEFAULT_PLAYER_ID;
    return resolvePlayerId(localStorage.getItem(PLAYER_STORAGE_KEY));
  } catch (err) {
    return DEFAULT_PLAYER_ID;
  }
};

export const savePlayerId = (playerId) => {
  const resolved = resolvePlayerId(playerId);
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(PLAYER_STORAGE_KEY, resolved);
    }
  } catch (err) {
    /* private mode */
  }
  return resolved;
};
